module.exports = __webpack_public_path__ + "static/media/meryl-marschall.edb87681.jpg";